import { all, call, fork, put, takeLatest, select } from "redux-saga/effects";
import ProductsActions, { ProductsTypes } from '../redux/Products';
import MessageActions from "../redux/Messages";
import AuthActions from "../redux/Auth";
import UserActions from "../redux/User";
import { 
  getProductsRequest,
  addProductRequest,
  deleteProductRequest,
  editProductRequest,
} from "../services/Products";

function* getProducts() {
  try {
    yield put(AuthActions.showAuthLoader())
    const { user: { id } } = yield select(state => state.user);
    const products = yield call(getProductsRequest, id);
    yield put(AuthActions.hideAuthLoader())
    yield put(ProductsActions.getProductsDone(products))
  } catch (error) {
    yield put(ProductsActions.getProductsError(error))
  }
}

function* addProduct({ majorId, form, history }) {
  yield put(AuthActions.showAuthLoader())
  yield call(addProductRequest, majorId, form);
  yield put(AuthActions.hideAuthLoader())
  yield put(MessageActions.showMessage('Producto creado con exito', false));
  yield put(MessageActions.hideMessage());
  history.push('/mayorDashboard/productsList');
}

function* deleteProduct({ productId }) {
  yield put(AuthActions.showAuthLoader())
  const { user: { id } } = yield select(state => state.user);
  yield call(deleteProductRequest, productId, id);
  const products = yield call(getProductsRequest, id);
  yield put(ProductsActions.getProductsDone(products))
  yield put(AuthActions.hideAuthLoader())
  yield put(MessageActions.showMessage('Producto eliminado con exito', false));
  yield put(MessageActions.hideMessage());
}

function* editProduct({ majorId, form, history }) {
  yield put(AuthActions.showAuthLoader())
  yield call(editProductRequest, majorId, form);
  yield put(AuthActions.hideAuthLoader())
  yield put(MessageActions.showMessage('Producto editado con exito', false));
  yield put(MessageActions.hideMessage());
  history.push('/mayorDashboard/productsList');
}

export function* getProductsWatcher() {
  yield takeLatest(ProductsTypes.GET_PRODUCTS, getProducts);
}

export function* addProductWatcher() {
  yield takeLatest(ProductsTypes.ADD_PRODUCT, addProduct);
}

export function* editProductWatcher() {
  yield takeLatest(ProductsTypes.EDIT_PRODUCT, editProduct);
}

export function* deleteProductWatcher() {
  yield takeLatest(ProductsTypes.DELETE_PRODUCT, deleteProduct);
}

export default function* rootSaga() {
  yield all([
    fork(getProductsWatcher),
    fork(addProductWatcher),
    fork(deleteProductWatcher),
    fork(editProductWatcher),
  ]);
}